import { createClient } from '@/shared/api/client'
import { TargetSystem } from '@/shared/constants'
import { buildUrl } from '@/shared/utils/urls'
import { validateResponseIsOk } from '@/shared/api/validation'

const client = createClient(buildUrl(TargetSystem.AssetManagement))

export async function removeReconFile(assetCode: string) {
  await validateResponseIsOk(
    client.sendDelete(['asset', assetCode, 'files'])
  )
}
